/**
 * @voltxampere/ui — 2N5109 RF amp transistor (Sprint 45-3, placeholder)
 *
 * PLACEHOLDER. Klasik RF wide-band amp BJT — DC stamp Sprint 7 ile
 * çalışır, S-parameters + RF noise figure modeling Sprint 50+'da.
 *
 * Reference: TI / On Semi 2N5109 — TO-39 metal can. RF power amp,
 * V_CEO = 20 V, I_C = 400 mA, β = 60, f_T = 1.2 GHz, NF = 3 dB @
 * 200 MHz, P_out = 1 W. HF/VHF amplifier + repeater + amateur
 * radio (legendary in 1970s ham radio scene). Klasik AT&T 70'ler
 * Bell Labs design.
 *
 *   Default mapping → bjt-npn schemaType:
 *     Is = 1e-14
 *     Bf = 60
 *     Vaf = 50
 *
 * Engine zero-diff invariant honored — canonical `bjt-npn` engine
 * type via schemaType.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { npn } from "../npn.js";
export const rf2n5109 = {
    id: "2n5109",
    nameTr: "2N5109 (RF Amp NPN 1.2GHz, TO-39, placeholder)",
    nameEn: "2N5109 (RF Amp NPN 1.2GHz, TO-39, placeholder)",
    shortcut: "Q",
    category: "active",
    viewBox: npn.viewBox,
    terminals: npn.terminals,
    defaultLabel: "Q",
    defaultValue: "2N5109",
    schemaType: "bjt-npn",
    defaultParams: { Is: 1e-14, Bf: 60, Vaf: 50 },
    renderSVG: () => npn.renderSVG(),
};
//# sourceMappingURL=rf-2n5109.js.map